import { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [unreadNotifications, setUnreadNotifications] = useState(0);
  const [unreadMessages, setUnreadMessages] = useState(0);
  const location = useLocation();

  useEffect(() => {
    fetchUnreadCounts();
  }, [location]);

  const fetchUnreadCounts = async () => {
    try {
      const [notifRes, statsRes] = await Promise.all([
        axios.get(`${API_URL}/api/notifications/unread-count`),
        axios.get(`${API_URL}/api/dashboard/stats`)
      ]);
      setUnreadNotifications(notifRes.data.count);
      setUnreadMessages(statsRes.data.unread_messages);
    } catch (error) {
      console.error('Failed to fetch unread counts:', error);
    }
  };

  return (
    <div className="app-layout">
      {/* Mobile overlay */}
      <div 
        className={`mobile-menu-overlay ${sidebarOpen ? 'open' : ''}`}
        onClick={() => setSidebarOpen(false)}
      />
      
      {/* Sidebar - Desktop */}
      <div className="hidden lg:block">
        <Sidebar 
          unreadNotifications={unreadNotifications}
          unreadMessages={unreadMessages}
        />
      </div>
      
      {/* Sidebar - Mobile */}
      <div className={`mobile-sidebar ${sidebarOpen ? 'open' : ''}`}>
        <Sidebar 
          onClose={() => setSidebarOpen(false)}
          unreadNotifications={unreadNotifications}
          unreadMessages={unreadMessages}
        />
      </div>
      
      {/* Main content */}
      <div className="main-content">
        <Header 
          onMenuClick={() => setSidebarOpen(true)}
          unreadNotifications={unreadNotifications}
        />
        <main className="page-content">
          <Outlet context={{ refreshCounts: fetchUnreadCounts }} />
        </main>
      </div>
    </div>
  );
}
